
import { useAuth } from "@/components/AuthProvider";
import { useStudentData } from "../overview/hooks/useStudentData";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ProgressCharts } from "./components/ProgressCharts";
import { useTranslations } from "@/hooks/useTranslations";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useLanguagePath } from "@/utils/language";

export const StudentProgress = () => {
  const { user } = useAuth();
  const { data: studentData, isLoading } = useStudentData(user?.id, user?.email);
  const { t } = useTranslations("progress");
  const { getPath } = useLanguagePath();

  const formatProgressData = (data: any[] | undefined = []) => {
    return data?.map(item => ({
      date: item.progress_date,
      value: item.training_consistency
    })) || [];
  };

  const formatWeightData = (data: any[] | undefined = []) => {
    return data?.map(item => ({
      date: item.assessment_date,
      peso: item.weight,
      gordura: item.body_fat_percentage,
      muscular: item.muscle_mass
    })) || [];
  };

  console.log("StudentProgress - Loading:", isLoading);
  console.log("StudentProgress - Student data:", studentData);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-4 border-b border-slate-100/50 dark:border-gray-700/50">
        <div>
          <h2 className="text-3xl font-bold tracking-tight gradient-text dark:text-white">{t("studentProgress.title")}</h2>
          <p className="text-muted-foreground dark:text-gray-300">
            {t("studentProgress.subtitle")}
          </p>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={getPath("/student-dashboard")} className="text-flame hover:text-flame/80">{t("breadcrumbs.dashboard")}</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-medium dark:text-white">{t("studentProgress.title")}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center py-12">
          <div className="animate-pulse flex flex-col items-center justify-center">
            <div className="h-12 w-12 bg-slate-200 dark:bg-gray-700 rounded-full mb-4"></div>
            <div className="h-4 bg-slate-200 dark:bg-gray-700 rounded w-24 mb-2"></div>
            <div className="h-4 bg-slate-200 dark:bg-gray-700 rounded w-16"></div>
          </div>
        </div>
      ) : !studentData ? (
        <Card className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-lg border border-slate-100/50 dark:border-gray-700/50">
          <CardHeader>
            <CardTitle className="dark:text-white">{t("studentProgress.noData.title")}</CardTitle>
          </CardHeader>
          <CardContent className="dark:text-gray-300">
            <p>{t("studentProgress.noData.description")}</p>
          </CardContent>
        </Card>
      ) : (
        <ProgressCharts 
          progressData={formatProgressData(studentData.progressData || [])}
          assessmentData={formatWeightData(studentData.physical_assessments || [])} 
          trainingSessionsData={studentData.trainingSessionsData || []}
          strengthData={studentData.strengthData || []}
        />
      )}
    </div>
  );
};
